module.exports = __webpack_public_path__ + "img/type1-bg1.764fd2d0.png";